import { Http } from '@/lib/http';

export class ForeclosureService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/settings/foreclosure-statuses/';
  }

  fetchForeclosureStatuses() {
    return this.httpClient().get(this.endpoint);
  }

  // createForeclosureStatuses(payload) {
  //   return this.httpClient().post(`${this.endpoint}`, payload)
  // }

  updateForeclosureStatuses(id, payload) {
    return this.httpClient().put(`${this.endpoint}${id}`, payload)
  }

  // removeForeclosureStatus(id) {
  //   return this.httpClient().delete(`${this.endpoint}${id}`)
  // }
}
